import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { SearchAllOrgsModalComponent } from './search-all-orgs-modal/search-all-orgs-modal.component';
import { SearchNpoAutocompleteComponent } from './search-npo-autocomplete/search-npo-autocomplete.component';
import { LocationFilteringModule } from '@features/location-filtering/location-filtering.module';

@NgModule({
  imports: [
    GCCoreModule,
    LocationFilteringModule
  ],
  declarations: [
    SearchAllOrgsModalComponent,
    SearchNpoAutocompleteComponent
  ],
  exports: [
    SearchAllOrgsModalComponent,
    SearchNpoAutocompleteComponent
  ]
})
export class OrganizationSearchModule { }
